module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-5.6b242cc5.jpg";